var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('web',{staticClass:"web"}),_c('pad',{staticClass:"pad"}),_c('phone',{staticClass:"phone"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }